<template>
    <div class="plowCloudBrief" >
        <topBack>{{$t('navName')[1]}}</topBack>
        <!-- 导航 -->
        <barF5></barF5>
        <header class="plowCloudNav flex-between-wrap">
            <div
                v-for="(item,index) in childNav"
                :key="index"
                class="navItem"
                :class="{'activeNav':index==nowIndex}"
                @click="changeNav($event,index)"
            >{{item.cate_name}}</div>
        </header>
        <barF5></barF5>

        <!-- 内容 -->
        <div class="container">
            <brief v-if="nowIndex == 0" :cateId="cateId"></brief>
            <lawPhase v-if="nowIndex == 1" :cateId="cateId"></lawPhase>
            <taoist v-if="nowIndex == 2" :cateId="cateId" :title="childNav[2].cate_name"></taoist>
            <mourning-article v-if="nowIndex == 3" :cateId="cateId" :title="childNav[3].cate_name"></mourning-article>
            <first-draft v-if="nowIndex == 4" :cateId="cateId"></first-draft>
            <brief2 v-if="nowIndex == 5" :cateId="cateId"></brief2>
            <memory v-if="nowIndex == 6" :cateId="cateId" :title="childNav[6].cate_name"></memory>
        </div>
        <!-- 去除底部button所占的位置 -->
        <!-- <empty></empty> -->
        <!-- 底部button -->
        <!-- <footer>
            <Button>{{$t('firstHome')}}</Button>
        </footer> -->
    </div>
</template>

<script>
import { getCateList } from "../../api/apis";
import {getNavName} from '../../common/js/common.js'
import topBack from "../../components/topBack.vue";
import barF5 from "../../components/barF5"; //空隙bar
import brief from "./brief"; //耕雲導師簡歷
import lawPhase from "./lawPhase"; //耕雲導師法相
import taoist from "./taoist"; //耕雲導師墨寶
import mourningArticle from "./mourningArticle"; //耕雲導師圆寂及哀悼文
import firstDraft from "./firstDraft "; //耕雲導師年谱初稿
import brief2 from "./brief2"; //耕雲導師安祥禪簡介
import memory from "./memory"; //耕雲導師永恆的懷念
import empty from "../../components/empty";
import Button from "../../components/button"; //返回首頁
export default {
    name: "plowCloud",
    components: {
        topBack,
        barF5,
        brief,
        lawPhase,
        taoist,
        mourningArticle,
        firstDraft,
        brief2,
        memory,
        empty,
        Button
    },
    props: {
        // childNav: {
        //     type: Array,
        //     default: () => [
        //         {
        //             name: "耕雲導師簡歷"
        //         },
        //         {
        //             name: "耕雲導師法相"
        //         },
        //         {
        //             name: "耕雲導師墨寶"
        //         },
        //         {
        //             name: "耕雲導師圆寂及哀悼文"
        //         },
        //         {
        //             name: "耕雲導師年谱初稿"
        //         },
        //         {
        //             name: "耕雲導師安祥禪簡介"
        //         },
        //         {
        //             name: "耕雲導師永恆的懷念"
        //         }
        //     ]
        // }
    },
    data() {
        return {
            nowIndex: 0, //击中菜单的index
            cateId: '', //击中菜单的id
            childNav: [
                // {
                //     id: 2,
                //     cate_name: "耕耘导师简历"
                // },
                // {
                //     id: 26,
                //     cate_name: "耕雲導師法相"
                // },
                // {
                //     id: 3,
                //     cate_name: "耕耘导师墨宝"
                // },
                // {
                //     id: 4,
                //     cate_name: "耕云导师圆寂及哀悼文"
                // },
                // {
                //     id: 25,
                //     cate_name: "耕雲導師年谱初稿"
                // },
                // {
                //     id: 5,
                //     cate_name: "安祥禅简介"
                // },
                // {
                //     id: 6,
                //     cate_name: "永恒的怀念"
                // }
            ] //菜单列表
        };
    },
    methods: {
        changeNav(e, index) {
            this.nowIndex = index;
            localStorage.setItem("nowIndex", index); //存本地存储，方便返回时，跳转到相应的的nowIndex
            this.cateId = this.childNav[index].id;
        }
    },
    created() {
        this.nowIndex = localStorage.getItem("nowIndex") || 0;
        getCateList().then(res => {
            // this.childNav = res[0];
           
            this.childNav=getNavName(res[0]);
            
            this.cateId = res[0][this.nowIndex].id || 2;
        });
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.plowCloudNav {
    /* display: grid;
    grid-template-columns: repeat(2, 49.5%);
    grid-column-gap: 0.15rem;
    grid-row-gap: 0.15rem; */
    padding: 0.64rem;
    text-align: left;
    
}

.navItem {
    width: 9.23rem;
    margin: 0.15rem 0;
    height: 1.71rem;
    line-height: 1.71rem;
    box-sizing: border-box;

    background-color: #f4f3ee;
    color: #666666;
    /* padding-left:1.07rem; */
    padding-left:0.6rem;
    font-size: 0.85rem;
    font-weight: 600;
}

.activeNav {
    background-color: #047bcd;
    color: #fff;
}

.container {
    /* padding: 0.64rem; */
    color: #333333;
    text-align: left;
}
</style>